<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsSubmapContainer',
  
})
</script>
<template>
  <div
    ref="subContainer"
    class="tlbs-submap-container"
  >
    <slot />
  </div>
</template>

<script setup lang="ts"  name="TlbsSubmapContainer">
import { ref, inject } from 'vue';
import { throttleWithFrame } from '../utils/index';
const subContainer = ref();
interface Props {
  isShow?: boolean,
  mapId: string,
  position: LatLng,
  offset: OffsetOption,
}

const props = withDefaults(defineProps<Props>(), {
  isShow: true,
});
watch(props, () => {
  onMapChanged();
});
const mapInstance: LooseObject | null = inject('mapInstance') || null;

const onMapChanged = () => {
  if (!mapInstance?.value) {
    return;
  }
  const { lat, lng } = props.position;
  // 经纬度坐标转容器像素坐标
  const pixel = mapInstance.value.projectToContainer(!lat || !lng
    ? mapInstance.value.unprojectFromContainer(new TMap.Point(0, 0))
    : new TMap.LatLng(
      lat,
      lng,
    ));
  // 使dom中心点对齐经纬度坐标点
  if (props.isShow) {
    subContainer.value.style.display = 'block';
    const left = `${pixel.getX() - subContainer.value.clientWidth / 2 + props.offset.x}px`;
    const top = `${pixel.getY() - subContainer.value.clientHeight / 2 + props.offset.y}px`;
    subContainer.value.style.transform = `translate(${left}, ${top})`;
  } else {
    subContainer.value.style.display = 'none';
  }
};
watchEffect(() => {
  if (mapInstance?.value) {
    const _listener = throttleWithFrame(onMapChanged); // 随动画帧节流
    // 初始时先执行一遍
    _listener();
    // mapInstance 变化时更改位置
    mapInstance.value?.on('move', _listener);
    mapInstance.value?.on('resize', _listener);
    mapInstance.value?.on('offset_changed', _listener);
  }
});

onUnmounted(() => {
  mapInstance?.value?.off('move', onMapChanged);
  mapInstance?.value?.off('resize', onMapChanged);
  mapInstance?.value?.off('offset_changed', onMapChanged);
});
</script>
